
// ============================================================================
// Field Formatting Utilities
// ============================================================================

/**
 * Format field name to be more readable (similar to HTML popup)
 */
export const formatFieldName = (key: string): string => {
  return key
    // Remove any curly braces
    .replace(/[{}]/g, '')
    // Convert snake_case to Title Case
    .replace(/_/g, ' ')
    // Capitalize first letter of each word
    .replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
};

